import { Button, ButtonPassThroughOptions, ButtonProps } from '@repo/atomic-components';
import { classNames } from 'primereact/utils';
import { FC, ReactNode } from 'react';

interface SplittedButtonProps extends ButtonProps {
  children: ReactNode;
  onClickSplitted: () => void;
  disabledSplitted?: boolean;
  loadingSplitted?: boolean;
  ptSplitted?: ButtonPassThroughOptions;
}

export const SplittedButton: FC<SplittedButtonProps> = ({
  children,
  onClickSplitted,
  disabledSplitted,
  loadingSplitted,
  ptSplitted,
  ...buttonProps
}) => {
  return (
    <div className={classNames('relative', 'flex flex-row items-center justify-center')}>
      <Button
        {...buttonProps}
        pt={{
          ...(!!buttonProps?.pt && { ...buttonProps.pt }),
          root: {
            className: classNames(
              buttonProps && buttonProps.pt && buttonProps.pt.root && 'className' in buttonProps.pt.root
                ? buttonProps.pt.root.className
                : '',
              'rounded-r-none',
            ),
          },
        }}
      />
      <div className={classNames('bg-fletchers-gray-50 h-[32px] w-0.5')} />
      <Button
        disabled={disabledSplitted}
        loading={loadingSplitted}
        icon="pi pi-arrow-right"
        onClick={onClickSplitted}
        pt={{
          ...(!!ptSplitted && { ...ptSplitted }),
          root: {
            className: classNames(
              ptSplitted && ptSplitted.root && 'className' in ptSplitted.root ? ptSplitted.root.className : '',
              'rounded-l-none',
            ),
          },
        }}
      />

      {children}
    </div>
  );
};
